export default (state, { payload: { show, isSuccess, bucket } }) => ({
  ...state,
  showNotificationsOptIn: show,
  showNotificationsOptInSuccess: isSuccess ?? false,
  notificationsOptInBucket: bucket ?? null
});
